<template>
<div class="chapter">
<div class="inner_page">
<h2 class="sigilnotintoc1" id="pgepubid00005">PREFACE</h2>
<p class="calibre5">The 5th Highland Light Infantry was originally known as the 19th Lanark Rifle Volunteers, one of the Volunteer units raised in 1859. In 1880, it became the 5th Lanark Volunteers. The connection with the Highland Light Infantry began in 1887, when it was named the 1st Volunteer Battalion Highland Light Infantry, a detachment of which served in the South African War. On the formation of the Territorial Force in 1909, the present name was adopted. The old history of the unit is contained in the Records of the Scottish Volunteer Force 1859-1908, by the late Lieut.-General J.M. Grierson, C.V.O., C.B., C.M.G.</p>
<p class="calibre5">This book deals with our record of service in the war 1914-1918, and we feel we need only say three things in the Preface:</p>
<p class="calibre5">1. The book is published privately for those who served with us and others interested.</p>
<p class="calibre5">2. It has been written by officers of the Battalion who were with us during the period of which they write.</p>
<p class="calibre5">3. It is written to the memory of our gallant comrades who fell and who themselves did so much to make this History.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?d046f118